export default {"src":"/_next/static/media/up-down-color.24182de2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};